var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "confirm-unlock" },
    [
      _c("HKLModal", {
        ref: "confirmModal",
        attrs: {
          title: _vm.$t("hint.unlock.success"),
          afterClose: _vm.navToLogin,
          hasCancelBtn: false,
          closable: true,
        },
      }),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "rejectModal",
          attrs: {
            afterClose: _vm.navToLogin,
            hasCancelBtn: false,
            closable: true,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("pre", [_vm._v(_vm._s(_vm.$t("hint.unlock.fail")))]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }